import { Redirect } from 'react-router-dom';

import PropTypes from 'prop-types';

import GenericFormContainer from '../../Forms/GenericFormContainer';

import EventForm from './EventForm';

const EventFormComponent = ({
  isCreate,
  onSubmit,
  onLoad,
  form,
  initialValues,
  url,
  isEventEditable,
  ...rest
}) => (
  <>
    {!isEventEditable && <Redirect to={url} />}
    <GenericFormContainer
      render={(props) => <EventForm {...props} {...rest} isCreate={isCreate} />}
      form={form}
      formData={[]}
      initialValues={initialValues}
      onLoad={onLoad}
      onSubmit={onSubmit}
      title={`${isCreate ? 'Add' : 'Edit'} Event`}
      submitText="Save Event"
      isFullWidthForm
      enableReinitialize
      disabled={isEventEditable}
    />
  </>
);

EventFormComponent.propTypes = {
  isCreate: PropTypes.bool.isRequired,
  onSubmit: PropTypes.func.isRequired,
  onLoad: PropTypes.func.isRequired,
  form: PropTypes.string.isRequired,
  initialValues: PropTypes.instanceOf(Object).isRequired,
  url: PropTypes.string.isRequired,
  isEventEditable: PropTypes.bool,
};

export default EventFormComponent;
